import { ConfigProps } from '@config/types'

const config = ({}: ConfigProps) =>
  ({ windowKey: '8l1ckD3buG' }) as const satisfies Record<string, unknown>

export default config
